/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

function SEO({ lang, meta, title }: { lang: string; meta: any; title: string }) {
    // const { siteData, siteStats } = useStaticQuery(
    //   graphql`
    //     query seo {
    //       siteData: site {
    //         siteMetadata {
    //           title
    //         }
    //       }
    //       siteStats: strapiStatistics {
    //         text
    //         stat {
    //           number
    //           id
    //           displayName
    //           name
    //         }
    //       }
    //     }
    //   `
    // )

    // todo: pass in usable image for seo.

    // const operatingStates = siteStats.stat.find((stat: { name: string }) => stat.name === 'operating-states')
    // const registeredPatients = siteStats.stat.find((stat: { name: string }) => stat.name === 'registered-patients')
    // const localDispensaries = siteStats.stat.find((stat: { name: string }) => stat.name === 'local-dispensaries')

    // const description: string = `Curaleaf is a leading medical and wellness cannabis operator in the United States. `
    //     + `We serve ${registeredPatients.number} registered patients across ${operatingStates.number} states. `
    //     + `Visit one of our ${localDispensaries.number} local dispensaries and consume Cannabis with Confidence.`;

    const description =
        'Curaleaf is a leading medical and wellness cannabis operator in the United States. We serve 350K+ registered patients across 23 states. Visit one of our 90 local dispensaries and consume Cannabis with Confidence.';

    return (
        <Helmet
            htmlAttributes={{
                lang
            }}
            title={title}
            titleTemplate={title || 'Curaleaf Connecticut'}
            meta={[
                {
                    name: 'description',
                    content: description
                },
                {
                    property: 'og:title',
                    content: title
                },
                {
                    property: 'og:locale',
                    content: 'en_US'
                },
                {
                    property: 'og:url',
                    content: 'https://ct.curaleaf.com/'
                },
                {
                    property: 'og:description',
                    content: description
                },
                {
                    property: 'og:type',
                    content: 'website'
                },
                {
                    property: 'og:site_name',
                    content: 'Curaleaf'
                },
                {
                    name: 'twitter:card',
                    content: 'summary'
                },
                {
                    name: 'twitter:title',
                    content: title
                },
                {
                    name: 'twitter:description',
                    content: description
                },
                {
                    name: 'og:image',
                    content:
                        'https://curaleaf.com/wp-content/uploads/2019/12/cl-hero-botany-of-cannabis.jpg'
                }
            ].concat(meta)}>
            <script src='https://cdn.blueconic.net/curaleaf.js'></script>
        </Helmet>
    );
}

SEO.defaultProps = {
    lang: 'en',
    meta: [],
    description: ''
};

SEO.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired
};

export default SEO;
